import { IconButton, TableRow } from "@mui/material";
import { Delete } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import CellLink from "../HOC/CustomComponents/CellLink";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import ShipmentRegion from "../HOC/CustomComponents/ShipmentRegion";
import CustomSpinner from "../HOC/FunctionComponents/CustomSpinner";

const useCollectionsDetails = ({
  type,
  approved,
  collectionShipments,
  setPickedShipment: removeShipment,
  saveCollectionLoad,
  TotalData
}) => {
  const { t } = useTranslation();

  const deleteShipment = (collection) => (
    <FixedTableCell component="th" scope="row">
      <IconButton
        size="small"
        disabled={!approved || saveCollectionLoad}
        onClick={() => {
          collectionShipments.forEach((i) => {
            if (i.shipment.id === collection.shipment.id) {
              i["pendingDelete"] = true;
            }
          });
          removeShipment((prev) => ({
            shipments: collectionShipments,
          }));
          // fireMutaion(filtered)
        }}
      >
        {collection["pendingDelete"] ? (
          <CustomSpinner name="ClockLoader" size={20} />
        ) : (
          <Delete />
        )}
      </IconButton>
    </FixedTableCell>
  );

  /* --------------------------------- CUSTM --------------------------------- */
  const custmTableHead = [
    "#",
    "code",
    "recipient",
    "destination",
    "recipientAddress",
    "packageDescription",
    "collectedAmount",
    removeShipment ? "" : null,
  ];

  const custmTableBody = (collection, index) => {
    return (
      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/shipments/${collection.shipment.id}`}>
          {collection.shipment.code}
        </CellLink>
        <FixedTableCell>{collection.shipment?.recipientName}</FixedTableCell>
        <ShipmentRegion
          pathname={`/admin/zone/${collection?.shipment.recipientZone.id}`}
          zone={collection?.shipment.recipientZone?.name}
          subzone={collection.shipment?.recipientSubzone.name}
        />
        <FixedTableCell>{collection.shipment?.recipientAddress}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.description}</FixedTableCell>
        <FixedTableCell>{collection?.collectedAmount}</FixedTableCell>
        {removeShipment && deleteShipment(collection)}
      </TableRow>
    );
  };

  const custmTableTotal = {
    collectedAmount: TotalData?.collectedAmount,
  };
  /* --------------------------------- DLVBY --------------------------------- */
  const autoPayCommissionDlvby = TotalData?.deliveryAgent?.autoPayCommission
  const dlvbyTableHead = [
    "#",
    "requestCode",
    "originBranch",
    "recipient",
    "senderName",
    "packageDescription",
    "shipmentStatus",
    "deliveryType",
    "totalCost",
    "deliveredAmount",
    "collectedFees",
    "returningDueFees",
    "collectedAmount",
    removeShipment ? "" : null,
  ];
  autoPayCommissionDlvby && dlvbyTableHead.splice(13, 0, "commission", "NetAmount");
  const dlvbyTableBody = (collection, index) => {
    return (
      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
        <FixedTableCell>{index + 1}</FixedTableCell>
        <CellLink pathname={`/admin/shipments/${collection.shipment.id}`}>
          {collection.shipment.code}
        </CellLink>
        <CellLink
          pathname={`/admin/branches/${collection.shipment.originBranch.id}`}
        >
          {collection.shipment.originBranch.name}
        </CellLink>
        <FixedTableCell>{collection.shipment?.recipientName}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.senderName}</FixedTableCell>

        <FixedTableCell>{collection.shipment?.description}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.status.name}</FixedTableCell>
        <FixedTableCell>
          {collection.shipment?.deliveryType?.name ??
            collection.shipment?.status.name}
        </FixedTableCell>
        <FixedTableCell>{collection.shipment?.totalAmount}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.deliveredAmount}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.collectedFees}</FixedTableCell>
        <FixedTableCell>{collection.shipment?.returningDueFees}</FixedTableCell>
        <FixedTableCell>{collection?.collectedAmount}</FixedTableCell>
        {autoPayCommissionDlvby && <FixedTableCell>{collection?.commission}</FixedTableCell>}
        {autoPayCommissionDlvby && <FixedTableCell>{collection?.collectedAmount - collection?.commission}</FixedTableCell>}
        {removeShipment && deleteShipment(collection)}
      </TableRow>
    );
  };
  const dlvbyTableTotal = {
    totalAmount: TotalData?.totalAmount,
    deliveredAmount: TotalData?.deliveredAmount,
    collectedFees: TotalData?.collectedFees,
    returningDueFees: TotalData?.returningDueFees,
    collectedAmount: TotalData?.collectedAmount
  };

  if (autoPayCommissionDlvby) {
    dlvbyTableTotal.totalCommission = TotalData?.totalCommission
    dlvbyTableTotal.total = TotalData?.collectedAmount - TotalData?.totalCommission
  }
  console.log(dlvbyTableTotal);
  const sumTableNumber = (shipment, tableTotal) => {
    Object.entries(tableTotal).forEach(([k, v]) => {
      k === "collectedAmount"
        ? (tableTotal[k] += shipment[k] ?? 0)
        : (tableTotal[k] += shipment.shipment[k] ?? 0);
    });
  };

  /* --------------------------------- Manifests Object --------------------------------- */

  const collectionObject = {
    CUSTM: {
      id: "1",
      customer: true,
      label: t("manifestDetails"),
      tableHead: custmTableHead,
      tableBody: custmTableBody,
      tableTotal: custmTableTotal,
      sumTableNumber,
    },
    DLVBY: {
      id: "2",
      customer: true,
      label: t("manifestDetails"),
      tableHead: dlvbyTableHead,
      tableBody: dlvbyTableBody,
      tableTotal: dlvbyTableTotal,
      sumTableNumber,
    },
  };

  return {
    details: collectionObject[type],
  };
};

export default useCollectionsDetails;
